import { useQuery } from 'react-query';

import api from '@API/api';
import { QueryConfig } from '@shared/api';

type LibraryMetric = {
  id: string;
  workspaceId: string;
  name: string;
  cometSql: string;
};

type CustomMetricsLibraryResponse = LibraryMetric[];

const getCustomMetricsLibrary = (workspaceId?: string) =>
  api.get(`/mpm/v2/custom-metrics/library?workspaceId=${workspaceId}`);

export function useCustomMetricsLibrary(
  { workspaceId }: { workspaceId?: string },
  config: QueryConfig<CustomMetricsLibraryResponse>
) {
  return useQuery(
    ['custom-metrics-library', { workspaceId }],
    () => getCustomMetricsLibrary(workspaceId),
    {
      ...config,
      enabled: !!workspaceId
    }
  );
}
